import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import "./AddRiskModal.css"; // 🎨 Scoped styling

const AddRiskModal = ({ show, onClose, onCreated, showToast }) => {
  const [form, setForm] = useState({
    name: "",
    criterion: "D",
    responsible: "",
    business_unit: "",
    process: "",
    ressources: [],
    menaces: [],
    consequences: {
      Strategic: 0,
      Financial: 0,
      Reputational: 0,
      Operational: 0,
      Legal: 0,
    },
  });

  const [ressourcesOptions, setRessourcesOptions] = useState([]);
  const [menacesOptions, setMenacesOptions] = useState([]);

  const fetchOptions = async () => {
    try {
      const [resR, resM] = await Promise.all([
        axios.get("/api/options_ressources.php"),
        axios.get("/api/options_menaces.php"),
      ]);
      setRessourcesOptions(resR.data?.ressources || []);
      setMenacesOptions(resM.data?.menaces || []);
    } catch (e) {
      showToast("Error loading select options", "danger");
    }
  };

  useEffect(() => {
    if (show) fetchOptions();
  }, [show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (e) => {
    const { name, selectedOptions } = e.target;
    const values = Array.from(selectedOptions).map((o) => o.value);
    setForm((prev) => ({ ...prev, [name]: values }));
  };

  const handleConsequenceChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      consequences: {
        ...prev.consequences,
        [name]: parseInt(value),
      },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("/api/add_risk.php", form);
      showToast("Risk added successfully!");
      onCreated();
      onClose();
    } catch (err) {
      showToast("Error while adding risk", "danger");
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="add-risk-modal"
    >
      <Form onSubmit={handleSubmit}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="bi bi-plus-circle me-2 text-warning" />
              Add New Risk
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
            />
          </div>

          <div className="modal-body">
            {/* 🔹 Line 1 */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <Form.Label>Criterion</Form.Label>
                <Form.Select name="criterion" value={form.criterion} onChange={handleChange}>
                  <option value="D">Availability</option>
                  <option value="I">Integrity</option>
                  <option value="C">Confidentiality</option>
                  <option value="T">Traceability</option>
                </Form.Select>
              </div>
              <div className="col-md-6 mb-3">
                <Form.Label>Responsible</Form.Label>
                <Form.Control
                  name="responsible"
                  value={form.responsible}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* 🔹 Line 2 */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <Form.Label>Business Unit</Form.Label>
                <Form.Control
                  name="business_unit"
                  value={form.business_unit}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <Form.Label>Process</Form.Label>
                <Form.Control
                  name="process"
                  value={form.process}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* 🔹 Risk Name */}
            <div className="mb-3">
              <Form.Label>Risk Name</Form.Label>
              <Form.Control
                name="name"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>

            {/* 🔹 Resources & Threats */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <Form.Label>Resources</Form.Label>
                <Form.Select
                  name="ressources"
                  multiple
                  value={form.ressources}
                  onChange={handleSelectChange}
                >
                  {ressourcesOptions.map((r) => (
                    <option key={r.id} value={r.id}>
                      {r.name} ({r.type})
                    </option>
                  ))}
                </Form.Select>
                <small className="text-secondary">Multiple selection</small>
              </div>
              <div className="col-md-6 mb-3">
                <Form.Label>Threats</Form.Label>
                <Form.Select
                  name="menaces"
                  multiple
                  value={form.menaces}
                  onChange={handleSelectChange}
                >
                  {menacesOptions.map((m) => (
                    <option key={m.id} value={m.id}>
                      {m.name}
                    </option>
                  ))}
                </Form.Select>
                <small className="text-secondary">Multiple selection</small>
              </div>
            </div>

            {/* 🔹 Consequences */}
            <div className="mb-3">
              <Form.Label>Consequences</Form.Label>
              <div className="row">
                {Object.entries(form.consequences).map(([category, value]) => (
                  <div className="col-md-4 mb-2" key={category}>
                    <Form.Label>{category}</Form.Label>
                    <Form.Control
                      type="number"
                      name={category}
                      value={value}
                      onChange={handleConsequenceChange}
                      min="0"
                      max="4"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-profile" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-profile btn-success">
              Add Risk
            </button>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default AddRiskModal;
